import {ValueObject} from '@s-ui/domain'

export class SessionAuthenticationValueObject extends ValueObject {
  #userData
  #logUser
  #consents

  static create({userData, logUser, consents}) {
    return new SessionAuthenticationValueObject({userData, logUser, consents})
  }

  /**
   * @constructor
   * @param {Object} deps
   * @param {UserDataCommonValueObject} deps.userData
   * @param {LogUserCommonValueObject} deps.logUser
   * @param {Object} deps.consents
   */
  constructor({userData, logUser, consents}) {
    super({userData, logUser})
  }

  getUserData() {
    return this._userData
  }

  getLogUser() {
    return this._logUser
  }

  getConsents() {
    return this._consents
  }
}
